import React, { useCallback, useEffect } from 'react';
import { getIn } from 'formik';
import DatePicker from '../../date-picker';
import { awsDateToJs, awsDateFormatter } from '../../../helpers/formatters';
import { FieldElementPropTypes } from '../propTypes';

const DateField = ({
  field: { id, name, label, mode, value, optional, defaultToEmpty, onChange: customOnChange, ...props },
  ctx: { setFieldValue, touched, errors, classes, setFieldTouched }
}) => {
  const onChange = useCallback(
    (date) => {
      setFieldValue(name || id, awsDateFormatter(date.value));
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(date, name);
      }
    },
    [setFieldValue, setFieldTouched, name, id]
  );

  useEffect(() => {
    if (!defaultToEmpty && !value) {
      setFieldValue(name || id, awsDateFormatter(new Date()));
    }
  }, []);

  return (
    <DatePicker
      key={id}
      id={id}
      name={name || id}
      placeholder={label}
      onChange={onChange}
      value={value && typeof value === 'string' ? awsDateToJs(value) : defaultToEmpty ? null : new Date()} // Avoid day change for timezone (aws returns date without time)
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      label={label}
      classes={classes[id]}
      {...props}
    />
  );
};

DateField.propTypes = FieldElementPropTypes;

export default DateField;
